/* src/app/shared/components/ag-notification-badge/ag-notification-badge.component.scss */
.badge-container {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: #70a8ff;
}
.badge-container p {
  color: #ffffff;
}
.size-xs {
  width: 6px;
  height: 6px;
}
.size-xs p {
  display: none;
}
.size-s {
  width: 8px;
  height: 8px;
}
.size-s p {
  display: none;
}
.size-m {
  width: 20px;
  height: 20px;
}
.size-m p {
  font-size: 12px;
}
.size-l {
  width: 24px;
  height: 24px;
}
/*# sourceMappingURL=ag-notification-badge.component.css.map */
